export default "__VITE_ASSET__ad0e2389__"